import { ApiError } from './api-error'
import type { EventView, GiftCardView, SerialTicketView } from './types'

export const handleError = (_view: EventView | GiftCardView | SerialTicketView, error: Error) => {
    if (error instanceof ApiError) {
        console.error('API error', error.code, error.message)
    } else {
        console.error(error)
    }

    alert(error.message) // TODO
}
